export enum WIDGET_PLAYLIST {
    /**
     * @value Number of videos to display
     * @description This text is use as a label to select how many videos are displayed in playlist
     */
    DISPLAYED_VIDEO_NUMBER = 'PLAY.DISPLAYED_VIDEO_NUMBER',
    /**
     * @value Display playlist
     * @description Text used to label an action allowing the user to display a playlist.
     * "Playlist" should not be translated.
     */
    DISPLAY_PLAYLIST = 'PLAY.DISPLAY_PLAYLIST',
    /**
     * @value List of videos
     */
    LIST_OF_VIDEOS = 'PLAY.LIST_OF_VIDEOS',
    /**
     * @value No playlist selected
     * @description Displayed when user have to pick a playlist in widget
     */
    NO_PLAYLIST_SELECTED = 'PLAY.NO_PLAYLIST_SELECTED',
    /**
     * @value Number of videos
     */
    NUMBER_OF_VIDEOS = 'PLAY.NUMBER_OF_VIDEOS',
    /**
     * @value Playlists
     * @description Text used has a title to indicate user can see the playlists
     */
    PLAYLISTS = 'PLAY.PLAYLISTS',
    /**
     * @value The selected playlist is no longer available. Pick another one
     * @description Text appears when user pick a playlist which is not available anymore
     */
    PLAYLIST_NO_LONGER_AVAILABLE = 'PLAY.PLAYLIST_NO_LONGER_AVAILABLE',
    /**
     * @value Published a playlist in %INSTANCE_NAME% > %VIDEO_GALLERY%
     * @description Text used to indicate to the user that a video playlist has been published in the video gallery of a particular instance (site).
     * "Playlist" should not be translated.
     */
    PUBLISHED_PLAYLIST_IN_GALLERY = 'PLAY.PUBLISHED_PLAYLIST_IN_INSTANCE_VIDEO_GALLERY',
    /**
     * @value Space between videos (px)
     * @description Text use as label to the input field which set the margin value
     */
    SETTINGS_ITEMS_MARGIN = 'PLAY.SETTINGS_ITEMS_MARGIN',
    /**
     * @value Number of videos per line
     * @description Text used as a label for the select field to set how many videos will be display in the widget.
     */
    SETTINGS_MAX_VIDEOS_PER_LINE = 'PLAY.SETTINGS_MAX_VIDEOS_PER_LINE',
    /**
     * @value Maximum number of videos to display. Small screens may have less videos displayed.
     * @description Used as helper to the input below
     */
    SETTINGS_MAX_VIDEOS_PER_LINE_HELPER = 'PLAY.SETTINGS_MAX_VIDEOS_PER_LINE_HELPER',
    /**
     * @value Player
     */
    SETTINGS_VIEW_MODE_PLAYER = 'FRONT.SETTINGS.VIEW_MODE_PLAYER',
    /**
     * This key is use in legacy app so there is not Lokalise key
     * @value Enable slideshow
     */
    SLIDESHOW_ENABLED = 'WIDGET_SETTINGS_SLIDESHOW_ENABLED',
    /**
     * @value Source
     * @description Subtitle of the setting asking the user to choose a video source file
     */
    SUBTITLE = 'WIDGET_PLAY.SETTINGS_SUBTITLE',
}
